import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/dots.module.scss';

const transform = {
    vertical: null,
    horizontal: 'rotate(-90deg)',
};

const propTypes = {
    direction: PropTypes.oneOf(['vertical', 'horizontal']),
    className: PropTypes.string,
};

const defaultProps = {
    direction: 'vertical',
    className: null,
};

const DotsIcon = ({ direction, className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="20.8"
        height="20.8"
        viewBox="0 0 20.8 20.8"
        fill="currentColor"
        stroke="none"
    >
        <g
            style={{ transformOrigin: 'center', transform: transform[direction] }}
            className={styles.dots}
        >
            <circle cx="10.4" cy="2.51" r="2.51" />
            <circle cx="10.4" cy="18.29" r="2.51" />
            <circle cx="10.4" cy="10.4" r="2.51" />
        </g>
    </svg>
);

DotsIcon.propTypes = propTypes;
DotsIcon.defaultProps = defaultProps;

export default DotsIcon;
